import { Schema } from '@bingads-webui-react/overreact';

const schemaToModelMapping = {
  customer: 'customer',
  account: 'account',
  campaign: 'campaign',
  audience_kpi_estimation_v2: 'audience_kpi_estimation_v2',
  campaign_ids_with_esc_budget_landscape: 'campaign_ids_with_esc_budget_landscape',
  use_esc_budget_landscape: 'use_esc_budget_landscape',
};

export const schema = new Schema(schemaToModelMapping, () => {});
